import React, { useState, useEffect, useRef } from 'react';
import { FiCheckCircle, FiClock, FiPlay, FiTrendingUp, FiChevronRight, FiChevronDown, FiZap } from 'react-icons/fi';

const RoadmapPage = () => {
  const [activePhase, setActivePhase] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const roadmapRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (roadmapRef.current) {
      observer.observe(roadmapRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const phases = [
    {
      id: 1,
      title: 'Исследование и планирование',
      period: 'Январь - Июнь 2025',
      status: 'completed',
      progress: 100,
      color: '#10B981',
      icon: <FiCheckCircle />,
      description: 'Получен лабораторный образец с рекордными параметрами',
      tasks: [
        'Выявление гена химозина с высокими показателями',
        'Получение продуцента K.lactis',
        'Определение его характеристик'
      ],
      achievements: [
        'Ген найден',
        'Получен продуцент и наработана лабораторная партия фермента',
        'Проведены опыты с этим ферментом, показавшие отличные результаты'
      ]
    },
    {
      id: 2,
      title: 'Получение гранта ФСИ',
      period: 'Июль 2025',
      status: 'completed',
      progress: 100,
      color: '#8B5CF6',
      icon: <FiCheckCircle />,
      description: 'Поддержка Фонда "Студенческий стартап"',
      tasks: [
        'Подготовка заявки на грант',
        'Защита проекта перед комиссией',
        'Заключение договора',
        'Получение медийного ресурса'
      ],
      achievements: [
        'Получено финансирование',
        'Расширена команда',
        'Доступ к менторской поддержке',
        'Про нас написали в федеральных СМИ'
      ]
    },
    {
      id: 3,
      title: 'Первые шаги юридического лица',
      period: 'Q4 2025',
      status: 'completed',
      progress: 100,
      color: '#8B5CF6',
      icon: <FiCheckCircle />,
      description: 'Продвижение компании и концепции',
      tasks: [
        'Получение резидентства в бизнес-инкубаторах',
        'Найти компании, которые заинтересованы в продукте',
        'Попасть на ярмарки для продвижения'
      ],
      achievements: [
        'Стали резидентами Академпарка',
        'Получены два письма с намерениями к сотрудничеству — LOI',
        'Получен билет "Сибирская венчурная ярмарка"'
      ]
    },
    {
      id: 4,
      title: 'Апробация в сыроделии',
      period: '2025',
      status: 'completed',
      progress: 100,
      color: '#10B981',
      icon: <FiCheckCircle />,
      description: 'Полутвёрдый сыр со сроком созревания 1,5 месяца сварен в СибНИИ сыроделия ФГБНУ ФАНЦА (Барнаул), органолептика оценена по ГОСТ 33630-2015',
      tasks: [
        'Наработка пробной партии',
        'Апробация в НИИ Сыроделия',
        'Оценка органолептических свойств'
      ],
      achievements: [
        'Сыр сварен и оценён по ГОСТ',
        'Получены высокие органолептические оценки',
        'Подтверждён выход по ТУ «Плеярь»'
      ]
    },
    {
      id: 5,
      title: 'Пилотные варки у сыроваров',
      period: '2026',
      status: 'in-progress',
      progress: 25,
      color: '#10B981',
      icon: <FiPlay />,
      description: 'Бесплатные опытные партии на площадках клиентов',
      tasks: [
        'Наработка пробной партии',
        'Апробация на сыроварнях',
        'Сбор обратной связи от производителей'
      ],
      achievements: [
        'Наработка фермента продолжается',
        'Достигнуты договорённости с НИИ и двумя сыроварнями',
        'Коррекция будет проведена после тестирования'
      ]
    },
    {
      id: 6,
      title: 'Разработка ТУ и декларации ЕАЭС',
      period: '2027',
      status: 'planned',
      progress: 0,
      color: '#6B7280',
      icon: <FiClock />,
      description: 'Ферментёр 10 л, выход на титр 10 000 у.е./мл',
      tasks: [
        'Разработка технических условий',
        'Оформление декларации соответствия ЕАЭС',
        'Подготовка документации для производства'
      ],
      achievements: []
    },
    {
      id: 7,
      title: 'Масштабирование производства',
      period: '2028–2029',
      status: 'planned',
      progress: 0,
      color: '#6366F1',
      icon: <FiTrendingUp />,
      description: 'Масштабирование 80 → 300 л, титр 25 000 у.е./мл, первые поставки 10–15 сыроварням',
      tasks: [
        'Увеличение объёма производства',
        'Онбординг первых клиентов',
        'Поддержка и мониторинг качества'
      ],
      achievements: []
    },
    {
      id: 8,
      title: 'Первые коммерческие поставки',
      period: '2030–2031',
      status: 'planned',
      progress: 0,
      color: '#EC4899',
      icon: <FiClock />,
      description: 'Линия 1000 л, 40+ клиентов и дистрибьюторы',
      tasks: [
        'Запуск промышленной линии',
        'Расширение клиентской базы',
        'Выход на дистрибьюторов'
      ],
      achievements: []
    }
  ];

  const togglePhase = (id) => {
    setActivePhase(activePhase === id ? null : id);
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'completed': return 'Завершено';
      case 'in-progress': return 'В процессе';
      case 'planned': return 'Запланировано';
      default: return '';
    }
  };

  const getStatusClass = (status) => {
    switch (status) {
      case 'completed': return 'status-completed';
      case 'in-progress': return 'status-in-progress';
      case 'planned': return 'status-planned';
      default: return '';
    }
  };

  const completedCount = phases.filter(p => p.status === 'completed').length;
  const inProgressCount = phases.filter(p => p.status === 'in-progress').length;
  const plannedCount = phases.filter(p => p.status === 'planned').length;

  return (
    <div className="roadmap-page">
      {/* Animated Hero Section */}
      <section className="roadmap-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="animated-title">
                <span className="title-line">Дорожная</span>
                <span className="title-line accent">карта</span>
              </h1>
              <p className="hero-subtitle">
                Следите за нашим прогрессом в реальном времени. Каждый этап — это шаг к реализации инноваций.
              </p>
            </div>
            <div className="hero-stats">
              <div className="stat-circle">
                <div className="stat-number">{completedCount}</div>
                <div className="stat-label">Завершено</div>
              </div>
              <div className="stat-circle">
                <div className="stat-number">{inProgressCount}</div>
                <div className="stat-label">В работе</div>
              </div>
              <div className="stat-circle">
                <div className="stat-number">{plannedCount}</div>
                <div className="stat-label">В планах</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Overall Progress - убран процент */}
      <section className="overall-progress">
        <div className="container">
          <div className="progress-header">
            <h2>Этапы реализации проекта</h2>
          </div>
          
          <div className="progress-milestones-container">
            <div className="progress-milestones">
              {phases.map((phase, index) => (
                <div 
                  key={phase.id}
                  className={`milestone ${phase.status}`}
                  style={{ left: `${(index / (phases.length - 1)) * 100}%` }}
                  onClick={() => togglePhase(phase.id)}
                >
                  <div className="milestone-dot" style={{ backgroundColor: phase.color }}>
                    {phase.icon}
                  </div>
                  <div className="milestone-label">{phase.title}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Interactive Timeline */}
      <section className="timeline-section" ref={roadmapRef}>
        <div className="container">
          <div className={`timeline-container ${isVisible ? 'visible' : ''}`}>
            <div className="timeline-line"></div>
            
            {phases.map((phase, index) => (
              <div 
                key={phase.id}
                className={`timeline-phase ${phase.status} ${activePhase === phase.id ? 'active' : ''} ${index % 2 === 0 ? 'left' : 'right'}`}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div 
                  className="phase-marker"
                  style={{ borderColor: phase.color }}
                  onClick={() => togglePhase(phase.id)}
                >
                  <div className="marker-icon" style={{ backgroundColor: phase.color }}>
                    {phase.icon}
                  </div>
                  <div className="marker-ring"></div>
                </div>

                <div className="phase-card">
                  <div className="phase-header">
                    <div className="phase-title-container">
                      <h3 className="phase-title">{phase.title}</h3>
                      <span className="phase-period">{phase.period}</span>
                    </div>
                    <div className={`phase-status ${getStatusClass(phase.status)}`}>
                      {getStatusText(phase.status)}
                    </div>
                    <button 
                      className="phase-toggle"
                      onClick={() => togglePhase(phase.id)}
                    >
                      {activePhase === phase.id ? <FiChevronDown /> : <FiChevronRight />}
                    </button>
                  </div>

                  <div className="phase-body">
                    <p className="phase-description">{phase.description}</p>
                    
                    {phase.status === 'in-progress' && (
                      <div className="phase-progress">
                        <div className="progress-label">
                          <span>Прогресс: {phase.progress}%</span>
                        </div>
                        <div className="progress-bar-small">
                          <div 
                            className="progress-fill-small"
                            style={{ 
                              width: `${phase.progress}%`,
                              backgroundColor: phase.color
                            }}
                          >
                            <div className="progress-shimmer"></div>
                          </div>
                        </div>
                      </div>
                    )}

                    {activePhase === phase.id && (
                      <div className="phase-details animated-details">
                        <div className="details-section">
                          <h4>Задачи этапа</h4>
                          <ul className="tasks-list">
                            {phase.tasks.map((task, i) => (
                              <li key={i}>
                                <FiZap className="task-icon" />
                                <span>{task}</span>
                              </li>
                            ))}
                          </ul>
                        </div>

                        {phase.achievements.length > 0 && (
                          <div className="details-section">
                            <h4>Достижения</h4>
                            <ul className="achievements-list">
                              {phase.achievements.map((achievement, i) => (
                                <li key={i}>
                                  <div className="achievement-badge">
                                    <FiCheckCircle />
                                  </div>
                                  <span>{achievement}</span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <style jsx>{`
        .roadmap-page {
          --primary: #3B82F6;
          --success: #10B981;
          --warning: #F59E0B;
          --muted: #6B7280;
          --danger: #EF4444;
          --purple: #8B5CF6;
          --pink: #EC4899;
          --indigo: #6366F1;
          
          background: linear-gradient(180deg, #0F172A 0%, #1E293B 100%);
          color: white;
          min-height: 100vh;
        }

        /* Герой-секция */
        .roadmap-hero {
          padding: 80px 0 40px;
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(139, 92, 246, 0.1) 100%);
          position: relative;
          overflow: hidden;
        }

        .roadmap-hero::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: 
            radial-gradient(circle at 20% 80%, rgba(59, 130, 246, 0.2) 0%, transparent 50%),
            radial-gradient(circle at 80% 20%, rgba(139, 92, 246, 0.2) 0%, transparent 50%);
          animation: pulse 4s ease-in-out infinite alternate;
        }

        @keyframes pulse {
          0% { opacity: 0.5; }
          100% { opacity: 1; }
        }

        .hero-content {
          display: flex;
          flex-direction: column;
          gap: 40px;
          position: relative;
          z-index: 1;
        }

        .hero-text {
          text-align: center;
        }

        .animated-title {
          font-size: 4rem;
          margin-bottom: 20px;
          line-height: 1.1;
        }

        .title-line {
          display: block;
          animation: slideUp 0.8s ease-out;
        }

        .title-line.accent {
          color: var(--primary);
          animation-delay: 0.2s;
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .hero-subtitle {
          font-size: 1.25rem;
          color: rgba(255, 255, 255, 0.8);
          max-width: 600px;
          margin-left: auto;
          margin-right: auto;
          animation: slideUp 0.8s ease-out 0.4s both;
        }

        .hero-stats {
          display: flex;
          gap: 30px;
          flex-wrap: wrap;
          justify-content: center;
          animation: slideUp 0.8s ease-out 0.6s both;
        }

        .stat-circle {
          width: 120px;
          height: 120px;
          text-align: center;
          padding: 20px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 50%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .stat-circle:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(59, 130, 246, 0.3);
        }

        .stat-number {
          font-size: 2.5rem;
          font-weight: 700;
          color: var(--primary);
        }

        .stat-label {
          font-size: 0.875rem;
          color: rgba(255, 255, 255, 0.6);
          margin-top: 5px;
        }

        /* Прогресс - без процента */
        .overall-progress {
          padding: 60px 0;
          background: rgba(255, 255, 255, 0.02);
        }

        .progress-header {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 40px;
        }

        .progress-header h2 {
          font-size: 2rem;
          color: #fff;
        }

        .progress-milestones-container {
          width: 100%;
          position: relative;
          min-height: 100px;
          margin-top: 20px;
        }

        .progress-milestones {
          position: relative;
          height: 80px;
        }

        .milestone {
          position: absolute;
          top: 0;
          transform: translateX(-50%);
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .milestone:hover {
          transform: translateX(-50%) scale(1.1);
          z-index: 10;
        }

        .milestone-dot {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 1.3rem;
          margin: 0 auto 8px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
          transition: all 0.3s ease;
          border: 2px solid rgba(255, 255, 255, 0.2);
        }

        .milestone.completed .milestone-dot {
          animation: pulseDot 2s ease-in-out infinite;
        }

        @keyframes pulseDot {
          0%, 100% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7); }
          50% { box-shadow: 0 0 0 10px rgba(16, 185, 129, 0); }
        }

        .milestone-label {
          font-size: 0.8rem;
          color: #fff;
          text-align: center;
          max-width: 160px;
          font-weight: 500;
          background: rgba(30, 41, 59, 0.9);
          padding: 6px 12px;
          border-radius: 20px;
          backdrop-filter: blur(4px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
          white-space: normal; /* Заменено с nowrap на normal */
          word-wrap: break-word; /* Добавлен перенос слов */
          overflow: visible; /* Заменено с hidden на visible */
        }

        /* Таймлайн - остался без изменений */
        .timeline-section {
          padding: 80px 0;
        }

        .timeline-container {
          position: relative;
          opacity: 0;
          transform: translateY(50px);
          transition: opacity 0.8s ease, transform 0.8s ease;
        }

        .timeline-container.visible {
          opacity: 1;
          transform: translateY(0);
        }

        .timeline-line {
          position: absolute;
          left: 50%;
          top: 0;
          bottom: 0;
          width: 2px;
          background: linear-gradient(to bottom, transparent, var(--primary), transparent);
          transform: translateX(-1px);
        }

        .timeline-phase {
          position: relative;
          margin-bottom: 80px;
          opacity: 0;
          transform: translateX(-50px);
          animation: slideInPhase 0.6s ease-out forwards;
        }

        .timeline-phase.right {
          transform: translateX(50px);
        }

        @keyframes slideInPhase {
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .phase-marker {
          position: absolute;
          left: 50%;
          top: 0;
          transform: translateX(-50%);
          width: 60px;
          height: 60px;
          border-radius: 50%;
          border: 2px solid;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s ease;
          z-index: 2;
          background: rgba(15, 23, 42, 0.9);
        }

        .phase-marker:hover {
          transform: translateX(-50%) scale(1.1);
        }

        .marker-icon {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 1.2rem;
        }

        .marker-ring {
          position: absolute;
          top: -10px;
          left: -10px;
          right: -10px;
          bottom: -10px;
          border: 2px solid;
          border-radius: 50%;
          opacity: 0;
          animation: ringPulse 2s ease-in-out infinite;
        }

        .timeline-phase.in-progress .marker-ring {
          opacity: 1;
        }

        @keyframes ringPulse {
          0%, 100% { transform: scale(1); opacity: 0.5; }
          50% { transform: scale(1.1); opacity: 1; }
        }

        .phase-card {
          width: calc(50% - 60px);
          margin-left: auto;
          background: rgba(30, 41, 59, 0.8);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 16px;
          padding: 24px;
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .timeline-phase.left .phase-card {
          margin-left: 0;
          margin-right: auto;
        }

        .phase-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, var(--primary), var(--purple));
          border-radius: 16px 16px 0 0;
        }

        .phase-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
        }

        .phase-card.active {
          box-shadow: 0 20px 40px rgba(59, 130, 246, 0.2);
        }

        .phase-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 16px;
        }

        .phase-title-container {
          flex: 1;
        }

        .phase-title {
          font-size: 1.5rem;
          margin-bottom: 4px;
          color: white;
        }

        .phase-period {
          font-size: 0.875rem;
          color: rgba(255, 255, 255, 0.6);
        }

        .phase-status {
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 0.75rem;
          font-weight: 500;
          margin: 0 12px;
          white-space: nowrap;
        }

        .status-completed {
          background: rgba(16, 185, 129, 0.2);
          color: var(--success);
          border: 1px solid var(--success);
        }

        .status-in-progress {
          background: rgba(16, 185, 129, 0.2);
          color: var(--success);
          border: 1px solid var(--success);
          animation: pulseStatus 2s ease-in-out infinite;
        }

        @keyframes pulseStatus {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.7; }
        }

        .status-planned {
          background: rgba(107, 114, 128, 0.2);
          color: var(--muted);
          border: 1px solid var(--muted);
        }

        .phase-toggle {
          background: none;
          border: none;
          color: rgba(255, 255, 255, 0.6);
          cursor: pointer;
          font-size: 1.2rem;
          transition: color 0.3s ease;
          padding: 4px;
          flex-shrink: 0;
        }

        .phase-toggle:hover {
          color: white;
        }

        .phase-description {
          color: rgba(255, 255, 255, 0.8);
          margin-bottom: 20px;
        }

        .phase-progress {
          margin-bottom: 20px;
        }

        .progress-label {
          display: flex;
          justify-content: space-between;
          margin-bottom: 8px;
          font-size: 0.875rem;
          color: rgba(255, 255, 255, 0.6);
        }

        .progress-bar-small {
          height: 6px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 3px;
          overflow: hidden;
        }

        .progress-fill-small {
          height: 100%;
          position: relative;
        }

        .progress-shimmer {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.4),
            transparent
          );
          animation: shimmer 2s infinite;
        }

        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }

        .phase-details {
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          padding-top: 20px;
          margin-top: 20px;
        }

        .animated-details {
          animation: slideDown 0.5s ease-out;
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .details-section h4 {
          font-size: 1rem;
          margin-bottom: 12px;
          color: white;
        }

        .tasks-list, .achievements-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .tasks-list li {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 8px;
          color: rgba(255, 255, 255, 0.8);
        }

        .task-icon {
          color: var(--warning);
          flex-shrink: 0;
        }

        .achievements-list li {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 8px;
          background: rgba(16, 185, 129, 0.1);
          padding: 8px 12px;
          border-radius: 8px;
          border: 1px solid rgba(16, 185, 129, 0.2);
        }

        .achievement-badge {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: var(--success);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 0.8rem;
          flex-shrink: 0;
        }

        /* Responsive */
        @media (min-width: 768px) and (max-width: 1024px) {
          .container {
            max-width: 900px;
            padding-left: 24px;
            padding-right: 24px;
          }

          .animated-title {
            font-size: 3rem;
          }

          .stat-circle {
            width: 100px;
            height: 100px;
          }

          .stat-number {
            font-size: 2rem;
          }

          .phase-card {
            width: calc(100% - 80px);
            margin-left: 80px !important;
            padding: 20px;
          }

          .timeline-line {
            left: 50px;
          }

          .phase-marker {
            left: 50px;
            width: 50px;
            height: 50px;
          }

          .marker-icon {
            width: 36px;
            height: 36px;
            font-size: 1rem;
          }

          .phase-title {
            font-size: 1.2rem;
          }

          .phase-period {
            font-size: 0.75rem;
          }
        }

        @media (max-width: 768px) {
          .hero-content {
            text-align: center;
          }

          .hero-stats {
            justify-content: center;
            gap: 15px;
          }

          .stat-circle {
            width: 90px;
            height: 90px;
            padding: 15px;
          }

          .stat-number {
            font-size: 1.8rem;
          }

          .stat-label {
            font-size: 0.7rem;
          }

          .animated-title {
            font-size: 2.5rem;
          }

          .phase-card {
            width: calc(100% - 70px);
            margin-left: 70px !important;
            padding: 16px;
          }

          .timeline-line {
            left: 40px;
          }

          .phase-marker {
            left: 40px;
            width: 50px;
            height: 50px;
          }

          .marker-icon {
            width: 36px;
            height: 36px;
            font-size: 1rem;
          }

          .progress-header {
            flex-direction: column;
            gap: 10px;
            text-align: center;
          }
          
          .milestone-dot {
            width: 40px;
            height: 40px;
            font-size: 1rem;
          }
          
          .milestone-label {
            font-size: 0.7rem;
            max-width: 120px;
          }
        }

        @media (max-width: 480px) {
          .container {
            padding-left: 12px;
            padding-right: 12px;
          }

          .hero-stats {
            gap: 10px;
          }

          .stat-circle {
            width: 80px;
            height: 80px;
            padding: 10px;
          }

          .stat-number {
            font-size: 1.5rem;
          }

          .phase-card {
            width: calc(100% - 70px);
            margin-left: 70px !important;
            padding: 12px;
          }

          .phase-header {
            flex-wrap: wrap;
            gap: 8px;
          }

          .phase-title {
            font-size: 1.2rem;
          }

          .phase-period {
            font-size: 0.7rem;
          }

          .phase-status {
            order: 3;
            margin: 5px 0 0 0;
            width: 100%;
            text-align: center;
          }

          .phase-toggle {
            position: absolute;
            top: 12px;
            right: 12px;
          }

          .timeline-line {
            left: 35px;
          }

          .phase-marker {
            left: 35px;
            width: 40px;
            height: 40px;
          }

          .marker-icon {
            width: 28px;
            height: 28px;
            font-size: 0.8rem;
          }
          
          .milestone-dot {
            width: 35px;
            height: 35px;
            font-size: 0.9rem;
          }
          
          .milestone-label {
            font-size: 0.6rem;
            max-width: 80px;
          }
        }
      `}</style>
    </div>
  );
};

export default RoadmapPage;